import { Injectable } from '@angular/core';
import { LanguageModel } from './language.model';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {
  languages: Array<LanguageModel> = new Array<LanguageModel>();
  currentLang = new BehaviorSubject('vn');
  constructor() {
    this.languages.push(
      { name: 'Tiếng Việt', code: 'vn' },
      { name: 'English', code: 'en' },
      //{ name: '日本語', code: 'jp' }
    );
  }

  getLanguages() {
    return this.languages;
  }
  getCurrentLang() {
    return this.currentLang.getValue();
  }
  setCurrentLang(newLang: string) {
    this.currentLang.next(newLang);
  }
}
